module.exports = __webpack_public_path__ + "img/Ueberdachung_1.4c1a8e0d.jpg";